import KosaList from "./KosaList";

export default KosaList;